module.exports = __webpack_public_path__ + "static/media/id5.21c0a3ec.jpg";